module.exports = __webpack_public_path__ + "static/img/10.a46013d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/10.png
// module id = D2Dj
// module chunks = 0